import Seo from "@/components/Seo";
import { useSite, siteText } from "@/context/SiteContext";
import RichText from "@/components/RichText";

export default function MentionsLegales() {
  const { settings } = useSite();

  // Le responsable de publication est repris automatiquement de l'onglet Association :
  // membre coché « directeur de la publication », sinon le rôle contenant « président »
  const bureau = settings?.bureau || [];
  const director = bureau.find((m) => m.directeur_publication);
  const pres = director || bureau.find((m) => (m.role || m.fonction || "").toLowerCase().includes("président"));
  const presidentName = pres?.name || "le président de l'association";
  const withPresident = (txt) => (txt || "").replaceAll("{president}", presidentName);

  const notice = withPresident(
    siteText(
      settings,
      "legal_notice_text",
      "**Les Sonneurs de la Côte**\nAssociation n° RNA : W626001985\nN° Siret : 82940944000023\nSiège social : 13, rue de Moscou — 62100 Calais\nE-mail : sonneursdelacote62@gmail.com\n\nResponsable de la publication : {president}\n\n**Hébergeur**\nInfinityFree — Kwikstaartlaan 42, Unit G1517, 3704 GS Zeist, Pays-Bas\nContact : hello@infinityfree.com"
    )
  );
  const privacy = siteText(
    settings,
    "legal_privacy_text",
    "Ce site n'utilise pas de cookies et ne collecte aucune information de trafic ni aucune donnée personnelle de navigation.\n\nLorsque vous nous écrivez via le formulaire de contact ou le formulaire d'inscription aux stages, les informations transmises (nom, adresse e-mail et contenu du message) servent uniquement à répondre à votre demande et sont conservées uniquement le temps de la conversation.\n\nAucune donnée n'est revendue ni partagée avec des tiers.\n\nPour toute question ou demande concernant vos données, vous pouvez écrire à : sonneursdelacote62@gmail.com"
  );

  return (
    <div data-testid="legal-page">
      <Seo title="Mentions légales" description="Mentions légales et protection des données personnelles du site des Sonneurs de la Côte." path="/mentions-legales" />
      <section className="border-b border-stone-200 bg-[#1E1B18] py-16 text-white">
        <div className="mx-auto max-w-6xl px-4 sm:px-6">
          <span className="text-xs font-bold uppercase tracking-widest text-amber-200">{siteText(settings, "page_legal_label", "Informations")}</span>
          <h1 className="mt-2 font-display text-4xl font-bold uppercase tracking-tight sm:text-6xl">Mentions légales</h1>
          <p className="mt-4 max-w-2xl text-sm leading-relaxed text-stone-300 sm:text-base">
            Identité de l'association, hébergement du site et protection de vos données personnelles.
          </p>
        </div>
      </section>

      <section className="bg-[#FAF6F0] py-16">
        <div className="mx-auto max-w-3xl space-y-8 px-4 sm:px-6">
          <article data-testid="legal-notice-section" className="rounded-2xl border border-stone-200 bg-white p-6 shadow-sm sm:p-10">
            <h2 className="font-display text-2xl font-bold uppercase text-[#1E1B18]">Mentions légales</h2>
            <RichText className="mt-4 text-sm leading-relaxed text-stone-700" text={notice} />
          </article>
          <article data-testid="legal-privacy-section" className="rounded-2xl border border-stone-200 bg-white p-6 shadow-sm sm:p-10">
            <h2 className="font-display text-2xl font-bold uppercase text-[#1E1B18]">Protection des données personnelles</h2>
            <RichText className="mt-4 text-sm leading-relaxed text-stone-700" text={privacy} />
          </article>
        </div>
      </section>
    </div>
  );
}
